import { Reducer } from 'redux';
import { BannerState, BannerTypes } from './types';

const INITIAL_STATE: BannerState = {
  data: [],
  loading: false,
  loaded: false,
};

const reducer: Reducer<BannerState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BannerTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BannerTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        loaded: true,
        data: action.payload.data,
      };
    case BannerTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
